<template>
  <div class="row">
    <div class="col-xl-4 col-lg-4 col-xxxl-4 col-sm-2">
      <div class="card mb-25 border-0 rounded-0 bg-white stats-box heigth-cards-dashboard-general radius-7">
        <div class="card-body pe-20 ps-20 pe-md-25 ps-md-25 pe-lg-15 ps-lg-15">
          <div class="d-flex align-items-center disposition-card-itens">
            <div class="icon position-relative rounded-circle text-center text-primary">
              <i class="ph ph-sun-horizon"></i>
            </div>
            <div class="title style-customized-cards-dashboard">
              <span class="d-block mb-7 fs-13 text-uppercase fw-medium text-dark-emphasis">
                AM
              </span>
              <h4 class="fw-black mb-8 lh-1">
                {{ getDashboardMonthCards.am }}
              </h4>
              <span class="fw-medium text-dark-emphasis">
                00:00 - 12:00
              </span>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="col-xl-2 col-lg-4 col-xxxl-4 col-sm-2">
      <div class="card mb-25 border-0 rounded-0 bg-white stats-box heigth-cards-dashboard-general radius-7">
        <div class="card-body pe-20 ps-20 pe-md-25 ps-md-25 pe-lg-15 ps-lg-15">
          <div class="d-flex align-items-center disposition-card-itens">
            <div class="icon position-relative rounded-circle text-center text-primary">
              <i class="ph ph-calendar-blank"></i>
            </div>
            <div class="title style-customized-cards-dashboard">
              <span class="d-block mb-7 fs-13 text-uppercase fw-medium text-dark-emphasis">
                Tamanho total
              </span>
              <h4 class="fw-black mb-8 lh-1">
                {{ (getDashboardMonthCards.total_size / (1024 * 1024)).toFixed(2) + " MB" }}
              </h4>
            </div>
          </div>
        </div>
      </div>
    </div>
    
    <div class="col-xl-2 col-lg-4 col-xxxl-4 col-sm-2">
      <div class="card mb-25 border-0 rounded-0 bg-white stats-box heigth-cards-dashboard-general radius-7">
        <div class="card-body pe-20 ps-20 pe-md-25 ps-md-25 pe-lg-15 ps-lg-15">
          <div class="d-flex align-items-center disposition-card-itens">
            <div class="icon position-relative rounded-circle text-center text-primary">
              <i class="ph ph-file-audio"></i>
            </div>
            <div class="title style-customized-cards-dashboard">
              <span class="d-block mb-7 fs-13 text-uppercase fw-medium text-dark-emphasis">
                Tamanho médio de arquivo
              </span>
              <h4 class="fw-black mb-8 lh-1">
                {{ (getDashboardMonthCards.average_size / (1024 * 1024)).toFixed(2) + " MB" }}
              </h4>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div class="row">
    <div class="col-xl-4 col-lg-4 col-xxxl-4 col-sm-2">
      <div class="card mb-25 border-0 rounded-0 bg-white stats-box heigth-cards-dashboard-general radius-7">
        <div class="card-body pe-20 ps-20 pe-md-25 ps-md-25 pe-lg-15 ps-lg-15">
          <div class="d-flex align-items-center disposition-card-itens">
            <div class="icon position-relative rounded-circle text-center text-primary">
              <i class="ph ph-cloud-moon"></i>
            </div>
            <div class="title style-customized-cards-dashboard">
              <span class="d-block mb-7 fs-13 text-uppercase fw-medium text-dark-emphasis">
                PM
              </span>
              <h4 class="fw-black mb-8 lh-1">
                {{ getDashboardMonthCards.pm }}
              </h4>
              <span class="fw-medium text-dark-emphasis">
                12:01 - 23:59
              </span>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="col-xl-2 col-lg-4 col-xxxl-4 col-sm-2">
      <div class="card mb-25 border-0 rounded-0 bg-white stats-box heigth-cards-dashboard-general radius-7">
        <div class="card-body pe-20 ps-20 pe-md-25 ps-md-25 pe-lg-15 ps-lg-15">
          <div class="d-flex align-items-center disposition-card-itens">
            <div class="icon position-relative rounded-circle text-center text-primary">
              <i class="ph ph-soundcloud-logo"></i>
            </div>
            <div class="title style-customized-cards-dashboard">
              <span class="d-block mb-7 fs-13 text-uppercase fw-medium text-dark-emphasis">
                Tempo total de gravação
              </span>
              <h4 class="fw-black mb-8 lh-1">
                {{ convertTime(getDashboardMonthCards.total_time) }}
              </h4>
            </div>
          </div>
        </div>
      </div>
    </div>
    
    <div class="col-xl-4 col-lg-4 col-xxxl-4 col-sm-2">
      <div class="card mb-25 border-0 rounded-0 bg-white stats-box heigth-cards-dashboard-general radius-7">
        <div class="card-body pe-20 ps-20 pe-md-25 ps-md-25 pe-lg-15 ps-lg-15">
          <div class="d-flex align-items-center disposition-card-itens">
            <div class="icon position-relative rounded-circle text-center text-primary">
              <i class="ph ph-cassette-tape"></i>
            </div>
            <div class="title style-customized-cards-dashboard">
              <span class="d-block mb-7 fs-13 text-uppercase fw-medium text-dark-emphasis">
                Tempo médio de gravação
              </span>
              <h4 class="fw-black mb-8 lh-1">
                {{ convertTime(getDashboardMonthCards.average_time) }}
              </h4>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent } from "vue";
import { mapGetters } from 'vuex';
import moment from 'moment';

export default defineComponent({
  name: "CardsDashboardMonth",
  data() {
    return {};
  },
  methods: {
    convertTime(time: number | string) {
      const totalSeconds = Math.max(0, Math.floor(Number(time) || 0)); // lida com "96000.01243"
      const d = moment.duration(totalSeconds, 'seconds');

      const hours = Math.floor(d.asHours()); // horas **totais**, não %24
      const minutes = d.minutes();
      const seconds = d.seconds();

      const pad = (n: number) => String(n).padStart(2, '0');
      return `${pad(hours)}:${pad(minutes)}:${pad(seconds)}`; // ex.: 26:40:00
    }
  },
  computed:{
    ...mapGetters([
      'getDashboardMonthCards'
    ])
  },
});
</script>